export enum UserType {
  SENIOR = 'SENIOR',
  ADMIN = 'ADMIN',
}
